import { render, staticRenderFns } from "./dataMember.vue?vue&type=template&id=ce3ba862"
import script from "./dataMember.vue?vue&type=script&lang=js"
export * from "./dataMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports